<template>
  <article class="offset-top-1">
    <VBanner />
    <transition name="fade" mode="out-in" appear>
      <VSpinner v-if="isLoading" key="busy" class="offset-top-2" />
      <router-view v-else key="content" v-bind="response" @captchaReload="onCaptchaReload"></router-view>
    </transition>
  </article>
</template>

<script>
import VSpinner from '@/components/Spinner';
import VBanner from '@/components/UI/Banner';
import Proxy from '@/proxies/UnbarringProxy';

export default {
  name: 'UnbarringContainer',

  components: {
    VSpinner,
    VBanner,
  },

  data() {
    return {
      isLoading: true,
      response: null,
    };
  },

  async created() {
    this.response = await new Proxy().init();
    this.$store.dispatch('unbarring/set', this.response.err);
    this.isLoading = false;
  },

  methods: {
    async onCaptchaReload() {
      const response = await new Proxy().captchaReload();
      this.response.captcha = response.captcha;
      this.response.isCaptchaReloadAllowed = response.isCaptchaReloadAllowed;
    },
  },
};
</script>
